import { useRouter } from 'next/router'
import { useState } from 'react'

import cn from 'classnames'

import ButtonBlue from '../../../../components/ui/button/_color/_blue'
import { useAppSelector } from '../../../../store/hooks'
import { selectedAuthStatus, LoginStatuses } from '../../../../store/reducers/users'

import ArrowsIcon from '../icons/arrows.svg'
import CycleIcon from '../icons/cycle.svg'
import DotsLeft from '../icons/dotsLeft.svg'
import DotsRight from '../icons/dotsRight.svg'
import DotsMobile from '../icons/dots_mobile.svg'

import { isValidEmail } from '../../../../utils/check-email'

import styles from './styles.module.scss'
import { StartNowProps } from './start-now.props'
import { useTranslation } from 'utils/use-translation'

export default function StartNow({ className }: StartNowProps) {
  const { t } = useTranslation()

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const [phoneOrEmail, setPhoneOrEmail] = useState<string>('')

  const signUp = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/dashboard',
      })
    } else {
      await router.push({
        pathname: '/user/sign-up',
        query: {
          isEmail: isValidEmail(phoneOrEmail),
          phoneOrEmail: phoneOrEmail,
        },
      })
    }
  }

  const changePhoneOrEmail = (event) => {
    setPhoneOrEmail(event.target.value)
  }
  return (
    <>
      <div className={cn(styles.start__desktop, className)}>
        <img className={styles.start__desktop__dotsLeft} src={DotsLeft} alt="dots left" />
        <img className={styles.start__desktop__dotsRight} src={DotsRight} alt="dots right" />
        <div className={styles.start__desktop__left}>
          <h2>{t('start_now')}</h2>
          <img src={ArrowsIcon} alt="arrows icon" />
        </div>
        <div className={styles.start__desktop__right}>
          <input type="text" onChange={changePhoneOrEmail} placeholder={t('your_email_phone')} />

          <ButtonBlue className={styles.start__desktop__right__btn} enterkeyhint="done" onClick={signUp}>
            {t('sign_up')}
          </ButtonBlue>
        </div>
      </div>

      <div className={cn(styles.start__mobile, className)}>
        <img className={styles.start__mobile__dotsLeft} src={DotsMobile} alt="dots mobile" />
        <img className={styles.start__mobile__dotsRight} src={DotsMobile} alt="dots mobile" />

        <div className={styles.start__mobile__header}>
          <h2>{t('start_now')}</h2>
          <img src={CycleIcon} alt="cycle icon" />
        </div>

        <div className={styles.input}>
          <input type="text" onChange={changePhoneOrEmail} placeholder={t('your_email_phone')} />
        </div>

        <ButtonBlue className={styles.start__mobile__btn} enterkeyhint="done" onClick={signUp}>
        {t('sign_up')}
        </ButtonBlue>
      </div>
    </>
  )
}
